import React, {createContext, useReducer, useCallback, useState} from 'react';

//import JSX from 'types/react';
/*
interface Actions {
    type: string;
    value: ToolbarProps;
}
*/



//TODO: convert any to relevant thing
/*export type ToolbarProps = {
    primary: ToolbarEntry[],
    primaryUrl: string,
    title: string|any,
    secondary: ToolbarEntry[],
    secondaryUrl: string
}*/


/*
interface ToolbarProviderProps {
    reducer: Reducer<ToolbarProps, Actions>;
    initState: ToolbarProps;
}*/

/*
interface InitContextProps {
    state: ToolbarProps;
    dispatch: Dispatch<Actions>;
}*/

export const ToolbarContext = createContext<ToolBarProviderValue>(null);

export const ToolbarDataContext = createContext<ToolBarData>(null);
//export const ToolbarRenderContext = createContext(initWith);
/*
const reducer = (state, action) => {
    switch (action.type) {
        case 'setContent':
            return {
                primary: action.value.primary,
                title: action.value.title,
                secondary: action.value.secondary
            };
        default:
            return state;
    }
};
*/

type ToolBarData = {
    primary: ToolbarEntry[],
    primaryUrl: string,
    secondary:ToolbarEntry[]
    title: string,
    secondaryUrl: string|number
};


export type ToolbarEntry = {
    type: string,
    label: string,
    tooltip: string,
    icon: string,
    callback: ()=>void
}



export type ToolBarPrimaryProps = Omit<ToolBarData,'secondary'>;

export type ToolBarSecondaryProps = Omit<ToolBarData,'primary'>;

export type ToolBarProviderValue = {
    setPrimary:(ToolBarPrimaryProps)=>void,
    setSecondary:(ToolBarSecondaryProps)=>void
};

export const ToolbarProvider = ({children})=> {
    const [toolbar,setToolbar] = useState<ToolBarData>(null);
    //const [toolbar,dispatch] = useReducer(reducer,initWith);
    /*const setToolbar = useCallback((newToolbar:ToolbarProps)=>{
        dispatch({type:'setContent',value:newToolbar});
    },[]);*/
    const setPrimary = useCallback(({primary:primary,primaryUrl:primaryUrl,title:title,secondaryUrl:secondaryUrl}:ToolBarPrimaryProps)=>{
        setToolbar((currentValue)=> {
            const newValue:ToolBarData = {primary:primary,primaryUrl:primaryUrl,title:'',secondaryUrl:'',secondary:[]};
            console.log('TBS PRIM',primaryUrl,currentValue?.primaryUrl,secondaryUrl,currentValue?.secondaryUrl)
            if (primaryUrl == currentValue?.primaryUrl && currentValue?.secondaryUrl == secondaryUrl) {
                newValue.secondary = currentValue?.secondary;
                newValue.secondaryUrl = currentValue?.secondaryUrl;
                newValue.title = currentValue?.title;
            } else {
                newValue.title = title;
            }
            return newValue;
        });
    },[]);
    const setSecondary = useCallback(({primaryUrl:primaryUrl,title:title,secondaryUrl:secondaryUrl,secondary:secondary}:ToolBarSecondaryProps)=>{
        setToolbar((currentValue)=> {
            // update primary URL to the new section, in case it changed otherwise it will be wiped when primary updates
            console.log('TBS SEC',primaryUrl,currentValue?.primaryUrl,secondaryUrl,currentValue?.secondaryUrl)
            const newValue:ToolBarData = {primary:currentValue?.primary,primaryUrl:primaryUrl,title:title,secondaryUrl:secondaryUrl,secondary:secondary};
            return newValue;
        });
    },[]);
    const setter = useCallback((parameter)=>{
        setToolbar(parameter);
    },[]);
    const [value] = useState({setToolbar:setter,setPrimary:setPrimary,setSecondary:setSecondary});

    //toolbar.setToolbar = setToolbar;
    return (
        <ToolbarContext.Provider value={value}>
            <ToolbarDataContext.Provider value={toolbar}>
                {children}
            </ToolbarDataContext.Provider>
        </ToolbarContext.Provider>
    );
}

/*
export const ToolbarProvider: React.FC<ToolbarProviderProps> = ({ reducer, initState, children }) => {
    const [state, dispatch] = useReducer(reducer, initState);
    //const value = { state, dispatch };
    const setToolbar = useCallback((newToolbar)=>{
        dispatch({type:'setContent',value:newToolbar});
    },[]);

    return (
        <ToolbarRenderContext.Provider value={state}>
            <ToolbarUpdateContext.Provider value={setToolbar}>
                {children}
            </ToolbarUpdateContext.Provider>
        </ToolbarRenderContext.Provider>
    );
};
*/